<template>
  <div class="wrapper box  box_v">
    <!--头部-->
    <page-head title="社区防疫" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
    </page-head>

    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <div class="btnsearch">
          <Button class="bkcc-btn del-btn" @click="handleBtn('init')">重置</Button>
          <Button class="bkcc-btn del-btn" @click="handleBtn('search')">搜索</Button>
          <Button class="bkcc-btn del-btn" @click="handleBtn('export')">导出</Button>
        </div>
        <div class="box">
          <div class="box_f1">
            <i-form ref="formInline" inline label-position="top">
              <row :gutter="40">
                <i-col span="6">
                  <FormItem label="姓名" prop="name">
                    <Input v-model="name" placeholder="请输入姓名" clearable @on-enter="initFangyiList" @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="身份证号" prop="cardno">
                    <Input v-model="cardno" placeholder="请输入身份证号" clearable @on-enter="initFangyiList" @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="联系电话" prop="phone">
                    <Input v-model="phone" placeholder="请输入联系电话" clearable @on-enter="initFangyiList"  @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="居住类型" prop="host">
                    <Select v-model="liveType" class="input" clearable @on-change="initFangyiList">
                      <!-- 1 自有房屋,2 租赁房屋,4 借住房屋,8 其它 -->
                      <Option :value="1" label="自有房屋">
                        <span>自有房屋</span>
                      </Option>
                      <Option :value="2" label="租赁房屋">
                        <span>租赁房屋</span>
                      </Option>
                      <Option :value="4" label="借住房屋">
                        <span>借住房屋</span>
                      </Option>
                      <Option :value="8" label="其它">
                        <span>其它</span>
                      </Option>
                    </Select>
                  </FormItem>
                </i-col>
              </row>
              <row :gutter="40">  
                <i-col span="6">
                  <FormItem :label="'何地回'+cityremark" prop="fromWhere">
                    <Cascader v-model="fromWhere" :data="areadata" :load-data="getArea" placeholder="请选择"
                    clearable @on-change="fromWhereChange" change-on-select></Cascader>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem :label="'回'+cityremark+'日期'" prop="backTime">
                    <DatePicker v-model="backTime" format="yyyy-MM-dd" placeholder="请选择"
                    clearable @on-change="initFangyiList"></DatePicker>
                  </FormItem>
                </i-col>
              
                <i-col span="6">
                  <FormItem label="个人症状" prop="symptomSelf">
                    <Select v-model="symptomSelf" multiple  @on-change="initFangyiList">
                      <Option v-for="item in symptomSelfList" :value="item.key" :key="item.key">{{ item.label }}
                      </Option>
                    </Select>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="是否审核" prop="host">
                    <Select v-model="checkStatus" clearable @on-change="statusChange">
                      <Option value="2" label="待审核">
                        <span>待审核</span>
                      </Option>
                       <Option value="10" label="二次审核">
                        <span>二次审核</span>
                      </Option>
                      <Option value="3" label="已满14天未审核">
                        <span>已满14天未审核</span>
                      </Option>
                      <Option value="1" label="审核通过">
                        <span>审核通过</span>
                      </Option>
                      <Option value="0" label="审核未通过">
                        <span>审核未通过</span>
                      </Option>
                    </Select>
                  </FormItem>
                </i-col>  
                 <i-col span="6">
                  <FormItem label="审核时间" prop="time">
                    <DatePicker v-model="time" type="daterange" placeholder="请选择时间" @on-change="initFangyiList"></DatePicker>
                  </FormItem>
                </i-col>  
                <i-col span="6">
                  <FormItem label="是否湖北归来人员" prop="host" v-if="!isWuhan">
                    <Select v-model="stayWuHan" class="input" clearable @on-change="initFangyiList">
                      <Option :value="1" label="是">
                        <span>是</span>
                      </Option>
                      <Option :value="0" label="否">
                        <span>否</span>
                      </Option>
                    </Select>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="户籍地" prop="fromWhere">
                    <Cascader v-model="domicilePalce" :data="areadata" :load-data="getArea" placeholder="请选择"
                    clearable @on-change="domicilePalceChange" change-on-select></Cascader>
                  </FormItem>
                </i-col>
                <i-col span="6">
                  <FormItem label="工作单位" prop="workPlace">
                    <Input v-model="workPlace" placeholder="请输入工作单位" clearable @on-enter="initFangyiList"  @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
                <i-col span="6" v-if="isJiedao">
                  <select-community ref="community" @communityChange="communityChange"></select-community>
                </i-col>
                <i-col span="6" v-else>
                  <FormItem label="所属小区" prop="host">
                    <Select v-model="zoneId" class="input" clearable @on-change="initFangyiList">
                      <Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </i-col>

                 <i-col span="6">
                  <FormItem label="年级" prop="host">
                    <Select v-model="gradeIndex" clearable>
                      <Option v-for="item in gradeList" :value="item.label" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </FormItem>
                </i-col>

                  <i-col span="6">
                  <FormItem label="班级" prop="host">
                    <Select v-model="classIndex" clearable>
                      <Option v-for="item in classList" :value="item.label" :key="item.value">{{ item.label }}</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </row>
              
              <row :gutter="40">  
                <i-col span="6" v-if="isJiedao">
                <FormItem label="所属小区" prop="host">
                    <Select v-model="zoneId" class="input" clearable @on-change="initFangyiList">
                      <Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </row>
            </i-form>
          </div>
        </div>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <div>
            <Button class="bkcc-btn del-btn" @click="delFangyi">删除</Button>
            <Button class="bkcc-btn del-btn" @click="addFangyi">新增</Button>
            <Button class="bkcc-btn del-btn" @click="importFile">导入</Button>
            <Button class="bkcc-btn del-btn" @click="checkPeople('',0)">审核通过</Button>
            <Button class="bkcc-btn del-btn" @click="exportPeopleCard('')">下载登记卡</Button>
          </div>
          <Table border :columns="settingColumn" :data="fangyiList" :loading="isTableLoading"
                 @on-selection-change="selectTableItem" @on-row-dblclick="clickRow"></Table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>
    <!--导入-->
    <Modal
      v-model="importModal"
      title="导入"
      width="660px"
      height="400px"
      :footer-hide="true"
    >
      <div class="note box">
        请上传符合模板要求的文件,支持.xlsx格式
        <a
          class="download"
          href="http://bkccshequ.oss-cn-beijing.aliyuncs.com/empty/2020/2/4/temp.xlsx"
          download="企业模板"
        >下载防疫信息模板</a>
      </div>
      <Upload
        ref="upload"
        :show-upload-list="false"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :headers="header"
        :action="actionuri"
        :on-success="handleSuccess"
        :on-progress="handleProgress"
        :on-error="handleError"
      >
        <Button :loading="uploadLoading" type="primary">导入防疫信息</Button>
      </Upload>
    </Modal>
    <Modal title="确认审核" v-model="showShenheModal" @on-cancel="cancelModal" @on-ok="checkPeople('',1)">
      <div>{{modalTitle}}</div>
    </Modal>
    <Modal title="确认" v-model="delModal" @on-cancel="cancelModal" @on-ok="delFangyiItem">
      <div>确认删除记录吗？删除后将无法恢复</div>
    </Modal>
    <Modal title="下载二维码" v-model="downloadCode" @on-cancel="cancelModal" :footer-hide="true">
      <div class="qrCodeUrl-wrapper">
        <div v-if="qrCodeUrl">
          <img :src="qrCodeUrl" class="qrCodeUrl"/>
          <div class="qrcode-btn" style="margin-bottom:15px" @click="downQrcode">下载信息填报码</div>
          <div class="qrcode-btn" @click="downChuruQrcode">下载通用出入码</div>
        </div>
      </div>
    </Modal>
    
  </div>
</template>

<script>
  import pageHead from '../../../components/head'
  import selectCommunity from '../../../components/selectCommunity'
  var that
  export default {
    name: 'fangyilist',
    components: {
      pageHead,
      selectCommunity
    },
    data() {
      return {
        page: 1,
        rows: 10,
        gradeIndex: "",
        classIndex: "", 
        gradeList:[],
        classList:[],
        name: '',
        cardno: '',
        phone: '',
        zoneId: '',
        zoneList: [],
        isLoadZoneList: false,
        time:[],
        domicilePalce:[],//户籍地
        fromWhere: [],//从何地回京
        backTime: '',//回京日期
        //1--咳嗽,2--感冒,4--发烧,8--乏力,16--呼吸困难,32--腹泻,64--其他,0--以上均无
        symptomSelf: '',
        stayWuHan:'',
        symptomSelfList: [{
          label: '咳嗽',
          key: 1,
        },
          {
            label: '发烧',
            key: 4,
          },
          {
            label: '其他',
            key: 64,
          }, {
            label: '无症状',
            key: 0,
          }],
        checkStatus: '2',
        areadata: [],//行政区域
        fangyiList: [],
        cityremark: '',
        btnList: [
          // {
          //   name: '搜索',
          //   type: 'search',
          //   loading: false,
          // }, {
          //   name: '重置',
          //   type: 'init',
          //   loading: false,
          //   btnType: 'default',
          // }, 
          {
            name:'下载二维码',
            type: 'qrcode',
            loading: false,
            btnType: 'default',
          },
          {
            name: '设置',
            type: 'set',
            loading: false,
          // }
          }, {
          name: '查重',
          type: 'removal',
          loading: false,
          }
          // , {
          //   name: '导出',
          //   type: 'export',
          //   loading: false,
          //   btnType: 'default',
          // }
        ],
        settingColumn: [],
        total: 0,
        isTableLoading: false,
        selectAppointment: [],
        communityId: 0,
        childShequ: [],
        isPermanent: '',
        erpmanentList: [{
          name: '本地',
          id: 1
        }, {
          name: '外地',
          id: 0
        }],
        liveType:'',
        liveTypeObj: {
          1: '自有房屋',
          2: '租赁房屋',
          4: '借住房屋',
          8: '其它',
        },
        qrCodeUrl: '',
        importModal: false,
        header: {
          //令牌，为上传图片使用
          token: window.sessionStorage.getItem("token")
        },
        actionuri: '',
        uploadLoading: false,
        showShenheModal:false,
        modalTitle:'',
        delId:'',
        delModal:false,
        //级联行政区域
        communityIdList:[],
        sel_Community:[],
        //判断是否为武汉
        isWuhan:false,
        downloadCode:false,
        workPlace:'',
      }
    },
    computed: {
      isJiedao() {
        return parseInt(this.$store.state.isJiedao);
      }
    },
    watch: {
      communityId(newVal) {
        //点击重置的时候 communityId变为0，此时不应获取当前社区下的微社区
        //watch 只针对当前为街道，才会发生communityId变化
        if (newVal != 0) {
          this.getZoneList(newVal)
        } else {
          this.zoneList = [];
          this.zoneId = ''
        }
      },
      '$route' (to, from) {
        if(from.name == "addFangyi")  this.getFangyiList()
      }
    },
    methods: {
      //获取行政区域
      getArea(item, callback) {
        item.loading = true;
        this.$post(this.urlobj.getArea + 'id=' + item.id).then(res => {
          let data = res.map(_item => {
            let resturn_data = {
              pid: _item.pid,
              id: _item.id,
              value: _item.text,
              label: _item.text,
              level: item.level + 1,
            }
            if (item.level != 2) {
              resturn_data.children = []
              resturn_data.loading = false
            }

            return resturn_data
          })
          if (item.level == 0) {
            this.areadata = data
          } else {
            item.loading = false;
            item.children = data
            callback()

          }

        }).catch(e => {
          this.$Message.error('获取行政区域失败')
        })
      },

      communityChange(value){
        console.log('============communityChange============')
        console.log(value)
        this.communityId = value.communityId
        this.communityIdList = value.childrenIdList
        this.initFangyiList()
      },
      initFangyiList() {
        this.page = 1
        this.getFangyiList()
      },
      getFangyiList() {
        let {page, rows, name, cardno, fromWhere, domicilePalce,phone, backTime, checkStatus, communityIdList, isPermanent,liveType,stayWuHan,zoneId,workPlace,gradeIndex,classIndex} = this
        let checkBeginTime='',checkEndTime=''
        if (this.time[0])  {
          checkBeginTime = this.$util.FormatDate(new Date(this.time[0]),'yyyy-MM-dd')
          checkEndTime = this.$util.FormatDate(new Date(this.time[1]),'yyyy-MM-dd')
        }
        let symptomSelf = 0;
        console.log(this.symptomSelf)
        if (this.symptomSelf === '' || this.symptomSelf.length == 0) {
          symptomSelf = ''
        } else {
          this.symptomSelf.forEach(item => {
            symptomSelf += item
          });
        }
        this.isTableLoading = true
        let data = {
          pageNum: page,
          pageSize: rows,
          name,
          cardno,
          phone,
          symptomSelf,
          stayWuHan,
          checkStatus: checkStatus?(parseInt(checkStatus)!=3?parseInt(checkStatus):2):'',
          communityIdList,
          isPermanent,
          liveType,
          zoneId,
          noCheckAndReturn14Day:parseInt(checkStatus) == 3?1:0,
          workPlace,
          checkBeginTime,
          checkEndTime,
          classAndGrade: (gradeIndex && classIndex)? gradeIndex + ',' + classIndex:''
        }

        data.fromWhere = fromWhere.join(',')
        data.domicilePalce = domicilePalce.join(',')
        if (backTime) data.backTime = this.$util.FormatDate(backTime, "yyyy-MM-dd");
        console.log(data)

        this.$post(this.urlobj.getFangyiList, data).then(res => {
          this.isTableLoading = false
          //if (!orderField && !orderSeq && !eventTypeId && !eventNameId && !res.total) this.isNoData = true
          this.total = res.total
          res.rows.forEach(item => {
            item.liveType = this.liveTypeObj[item.liveType]
          })
          this.fangyiList = res.rows

        })
      },
      export() {
        let {page, rows, name, cardno, fromWhere,domicilePalce, phone, backTime, checkStatus, communityIdList, isPermanent,liveType,stayWuHan,zoneId,workPlace} = this
        let symptomSelf = 0;
        let checkBeginTime='',checkEndTime=''
        if (this.time[0])  {
          checkBeginTime = this.$util.FormatDate(new Date(this.time[0]),'yyyy-MM-dd')
          checkEndTime = this.$util.FormatDate(new Date(this.time[1]),'yyyy-MM-dd')
        }
        if (this.symptomSelf === '' || this.symptomSelf.length == 0) {
          symptomSelf = ''
        } else {
          this.symptomSelf.forEach(item => {
            symptomSelf += item
          });
        }
        backTime = backTime?this.$util.FormatDate(backTime, "yyyy-MM-dd"):"";
        checkStatus = checkStatus?(parseInt(checkStatus)!=3?parseInt(checkStatus):2):'';
        let _14Day = parseInt(checkStatus) == 3?1:0

        let beginTime=""
        let endTime = ""
        if(name === undefined) name = ""
        if(cardno === undefined) cardno = ""
        if(fromWhere === undefined) fromWhere = []
        if(domicilePalce === undefined) domicilePalce = []
        if(phone === undefined) phone = ""
        if(backTime === undefined) backTime = ""
        if(checkStatus === undefined) checkStatus = ""
        if(communityIdList === undefined) communityIdList = []
        if(isPermanent === undefined) isPermanent = ""
        if(liveType === undefined) liveType = ""
        if(stayWuHan === undefined) stayWuHan = ""
        if(zoneId === undefined) zoneId = ""
        if(workPlace === undefined) workPlace = ""

        let url = this.urlobj.exportFangyiList + '?province=' + this.cityremark + '&communityId=' + this.$store.state.streetorcommunityid + '&token=' + this.$store.state.access_token
        + '&userName=' + name + '&idCardNO=' + cardno + '&phoneNO=' + phone
        + '&fromWhere=' + fromWhere.join(',') + '&domicilePalce=' + domicilePalce.join(',') + '&backTime=' + backTime + '&symptomSelf=' + symptomSelf
        + '&checkStatus=' + checkStatus + '&noCheckAndReturn14Day=' + _14Day + '&isPermanent=' + isPermanent
        + '&liveType=' + liveType + '&communityIdList=' + communityIdList + '&zoneId=' + zoneId+ '&workPlace=' + workPlace
        + '&stayWuHan=' + stayWuHan + '&beginTime=' + beginTime + '&endTime=' + endTime + '&checkBeginTime=' + checkBeginTime + '&checkEndTime=' + checkEndTime

        window.open(url)
      },
      handleBtn(type) {
        if (type == 'export') {
          this.export()
        } else if (type == 'search') {
          this.initFangyiList()
        } else if (type == 'set') {
          this.$router.push({name: 'fangyiSet'})
        } else if (type == 'removal') {
          this.$router.push({name: 'epidemicRemoval', query: {cityremark: this.cityremark}})
        } else if (type == 'init') {
          this.name = ''
          this.cardno = ''
          this.fromWhere = []
          this.domicilePalce=[]
          this.phone = ''
          this.backTime = ''
          this.symptomSelf = ''
          this.stayWuHan = ''
          this.checkStatus = "2"
          this.communityId = 0
          this.communityIdList = []
          this.$store.state.isJiedao && (this.$refs.community="");
          this.isPermanent = ''
          this.liveType = ""
          this.zoneId = ''
          this.workPlace = ''
          this.time = []
          this.gradeIndex = "";
          this.classIndex = "";
          this.initFangyiList()
        }else if(type== 'qrcode'){
          this.downloadCode=true
        }
      },
      getDetail(index) {
        this.$router.push({
          name: 'fangyidetail',
          query: {id: this.fangyiList[index].id, communityId: this.fangyiList[index].communityId}
        })
      },
      delItem(index) {
        this.delModal = true
        this.delId = this.fangyiList[index].id
        //this.delFangyiItem(this.fangyiList[index].id)
      },
      addFangyi() {
        this.$router.push({name: 'addFangyi'})
      },
      delFangyi() {
        var id = this.selectAppointment.map(item => item.id).join(',')
        if (!id) {
          this.$Message.warning('请选择要操作的记录')
          return
        }
        this.delModal = true
        this.delId = id
        //this.delFangyiItem(id)
      },
      delFangyiItem() {
        var url = this.urlobj.delFangyiList + '?idList=' + this.delId
        this.$delete(url).then(res => {
          this.$Message.success('删除成功')
          this.initFangyiList()
        })
      },
      cancelModal(){

      },
      pageChange(val) {
        this.page = val;
        this.getFangyiList();
      },
      selectTableItem(value) {
        this.selectAppointment = value
        //this.selectAppointment = this._.unionBy(this.selectAppointment, value, 'id')
      },
      // cancelTableItem() {
      //   var value = arguments[1]
      //   var delIndex
      //   this.selectAppointment.forEach((item, index) => {
      //     if (item.id == value.id) delIndex = index
      //   })
      //   this.selectAppointment.splice(delIndex, 1)
      // },
      clickRow(value) {
        this.$router.push({
          name: 'fangyidetail',
          query: {
            id: value.id,
            communityId: value.communityId
          }
        })
      },
      getCity(id) {
        this.$get(this.urlobj.getCity + 'id=' + id).then(res => {
          let cityid = res.rows[0].path.split('.')[2]
          this.getCityName(cityid)
        }).catch(e => {

        })
      },
      getCityName(id) {
        this.$get(this.urlobj.getCity + 'id=' + id).then(res => {
          this.cityremark = res.rows[0].remark || ''
          this.isWuhan = res.rows[0].pathname.indexOf('武汉')>-1?true:false
          sessionStorage.setItem('isWuhan', this.isWuhan)
          sessionStorage.setItem('cityremark', this.cityremark)
          this.initTableTitle()
        }).catch(e => {

        })
      },
      /* 获取年级字典 */
      getGradeList() {
        let url = this.urlobj.dictionaryList("grade");
        return new Promise((resolve, reject) => {
          this.$get(url)
            .then(res => {
              resolve(res);
            })
            .catch(e => console.log(e));
        });
      },
      /* 获取班级字典 */
      getClassList() {
        let url = this.urlobj.dictionaryList("class");
        return new Promise((resolve, reject) => {
          this.$get(url)
            .then(res => {
              resolve(res);
            })
            .catch(e => console.log(e));
        });
      },
      getGradeAndClassList() {
        var getGradeList = this.getGradeList();
        var getClassList = this.getClassList();
          Promise.all([getGradeList, getClassList]).then(res => {
            console.log(res);
              this.gradeList =  res[0].rows.map(item => {
                    return {
                      label: item.dicName,
                      value: item.id
                    };
              })
              this.classList =  res[1].rows.map(item => {
                    return {
                      label: item.dicName,
                      value: item.id
                    };
              })
              
          })
      },
      initTableTitle() {
        this.settingColumn = [
          {
            type: 'selection',
            width: 70,
            align: 'center',
            fixed: 'left'
          },
          {
            title: "姓名",
            width: '95',
            resizable: true,
            key: "name",
            fixed: 'left'
          },
          {
            title: "身份证号",
            key: 'cardno',
            resizable: true,
            width:'200',
          },
          {
            title: "联系电话",
            key: "phone",
            resizable: true,
            width:'130',
          },
          {
            title: '居住类型',
            key: 'liveType',
            width:'100',
          },
          {
            title: "何地回" + this.cityremark,
            key: "fromWhere",
            width:'150',
          },
          {
            title: "回" + this.cityremark + "日期",
            key: "backTime",
            width:'150',
          },
          {
            title: "个人症状",
            width: '95',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.getArrayText(that.fangyiList[params.index].symptomSelf)
                  )
                ]);
            }
          },
          {
            title: "登记时间",
            key: "createTime",
            width:'120',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.fangyiList[params.index].createTime.substring(0,that.fangyiList[params.index].createTime.length-2)
                  )
                ]);
            }
          },
          {
          title: "审核时间",
          key: "checkTime",
          width:'120',
          render: function (h, params) {
            return h("div",
              [
                h(
                  "span",
                  that.fangyiList[params.index].checkTime && that.fangyiList[params.index].checkTime.substring(0,that.fangyiList[params.index].checkTime.length-2)
                )
              ]);
          }
          }, {
            title: '户籍地',
            key: 'domicilePalce',
            width:'200',
          }, {
            title: '工作单位',
            key: 'workPlace',
            width:'200',
          },{
            title: "行政区域",
            key: "communityName",
            resizable: true,
            width:'150',
          }, {
            title: "所属小区",
            key: "zoneName",
            resizable: true,
            width:'150',
          },
          {
            title: "年级和班级",
            key: "classAndGrade",
            resizable: true,
            width:'150',
          },
          {
            title: "去过重点地区/中高风险地区",
            key: "beenRiskAreaName",
            resizable: true,
            width:'200',
          },
          {
            title: "是否审核",
            width: '95',
            fixed: 'right',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: that.getStatus(that.fangyiList[params.index].checkStatus).color,
                      },
                    },
                    that.getStatus(that.fangyiList[params.index].checkStatus).label
                  )
                ]);
            }
          },
          {
            title: "操作",
            width: 240,
            fixed: 'right',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.getDetail(params.index)
                        }
                      }
                    },
                    "[详情]"
                  ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.delItem(params.index)
                        }
                      }
                    },
                    "[删除]"
                  ),
                  // h(
                  //   "span",
                  //   {
                  //     style: {
                  //       color: "#5e6d94",
                  //       marginLeft: "10px",
                  //     },
                  //     on: {
                  //       click: (e) => {
                  //         e.stopPropagation()
                  //         that.checkPeople(that.fangyiList[params.index].id)
                  //       }
                  //     }
                  //   },
                  //   "[审核]"
                  // ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.exportPeopleCard(that.fangyiList[params.index].id)
                        }
                      }
                    },
                    "[下载登记卡]"
                  ),
                ]);
            }
          },
        ]
        this.getFangyiList()
      },
      getStatus(checkStatus){
        let obj = {
          label:'',
          color:'',
        }
        switch (checkStatus){
          case 1:
            obj = {
              label:'审核通过',
              color:'#00c066',
            }
            break;
          case 2:
            obj = {
              label:'待审核',
              color:'#eb7b29',
            }
            break;
          case 0:
            obj = {
              label:'审核未通过',
              color:'#fb4343',
            }
            break;
        }
        return obj

      },
      //审核居民信息
      checkPeople(val,isMust) {
        var ids = val ? val : this.selectAppointment.map(item => item.id).join(',')
        if (!ids) {
          this.$Message.warning('请选择要审核的记录')
          return
        }
        let data = {
          ids,
          checkStatus: 1,
        }
        if(isMust==1) data.isMust = 1
        this.$post(this.urlobj.checkPeople, data).then(res => {
            this.getFangyiList()
        }).catch(e => {
          console.log(e)
          if(e.data.code == 900190){
            this.showShenheModal = true
            this.modalTitle = e.data.message
          }
        })
      },
      //下载居民登记卡
      exportPeopleCard(val) {
        var id = val ? val : this.selectAppointment.map(item => item.id).join(',')
        console.log(id)
        if (!id) return this.$Message.error('请选择要下载的居民')
        window.open(this.urlobj.exportPeopleCard + '?ids=' + id + '&token=' + this.$store.state.access_token)
      },
      //复选框回写
      //复选框回写成数据
      getArrayText(val) {
        let arr = this.getIndexAry(val)
        let arr_text = this.symptomSelfList.filter(item => arr.indexOf(item.key) > -1)
        return arr_text.length ? arr_text.map(item => item.label).join(',') : ''
      },
      // 对复选框数值分解
      getIndexAry(num) {
        let arr = Number(num)
          .toString(2)
          .split("");
        let len = arr.length - 1;

        let res = arr.map((item, index) => {
          if (+item) return +item * 2 ** (len - index);
        });

        if (arr.length == 1 && arr[0] == 0) return [0]
        else return res ? res : [];
      },
      getChildShequ() {
        var url = this.urlobj.getChildShequ;
        this.$get(url).then(res => {
          var item = {
            name: '全部',
            id: 0,
          }
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          list.unshift(item)
          this.childShequ = list
        });
      },
      getQrcode() {
        // console.log(this.userList[0].communityId)
        console.log(this.$store.state.apptype)
        let apptype = this.$store.state.apptype;
        var communityId = this.$store.state.streetorcommunityid
        let url = this.urlobj.getQrCode(communityId, apptype)
        this.$get(url).then(res => {
          this.qrCodeUrl = res.newPrimaryKeys.qrcodeUrl
          console.log(this.qrCodeUrl)
        })
      },
      downQrcode() {
        window.open(
          this.urlobj.walkRecordDownload + '?comeIdList=' + this.$store.state.streetorcommunityid + '&comeType=0&token='+ this.$store.state.access_token
        );
      },
      downChuruQrcode(){
        let url = `${this.urlobj.walkRecordDownload}?token=${this.$store.state.access_token}&comeType=90&comeIdList=${this.$store.state.streetorcommunityid}`;
        window.open(url);
      },
      importFile() {
        this.importModal = true
      },
      handleProgress() {
        this.uploadLoading = true;
      },
      handleSuccess(response) {
        this.uploadLoading = false;
        this.importModal = false;
        if (response.isSucceed)  this.$Message.success(response.message)
        else this.$Message.error(response.message)
        this.initFangyiList()
      },
      handleError() {
        this.uploadLoading = false;
        this.importModal = false;
        this.$Message.error("导入失败");
      },
      // 下载模板
      downModel() {
        let url = this.urlobj.downQy + "?communityId=" + this.$store.state.streetorcommunityid;
        window.open(url);
      },
      //获取微社区列表
      getZoneList(id) {
        this.isLoadZoneList = true
        let url = this.urlobj.zoneList
        this.$get(url, {
          communityId: id,
          zoneType:1,
          hasChild:1
        }).then(res => {
          this.isLoadZoneList = false
          this.zoneList = res.rows
          this.zoneList.push({
            zoneId:0,
            zoneName:'其他'
          })
        }).catch(e => {
          this.isLoadZoneList = false;
          console.log(e)
        })
      },
      //点击选择微社区列表时
      selectZone(val) {
        if (val) {
          //下拉框展开，且communityId为空
          if (!this.communityId) {
            this.$Message.info('请先选择社区')
          } else if (this.isLoadZoneList) {
            this.$Message.info('查询中,请稍后')
          }
        }
      },
      domicilePalceChange(value){
        this.domicilePalce = value
        this.initFangyiList()
      },
      fromWhereChange(value){
        this.fromWhere = value
        this.initFangyiList()

      },
      statusChange(value){
        this.checkStatus = value?value:""
        this.initFangyiList()
      }
    },
    created() {
      this.getCity(this.$store.state.streetorcommunityid)
      this.getGradeAndClassList()
    },
    mounted() {
       this.getArea({id: '100000000000', level: 0})
      this.actionuri = this.urlobj.importFangyi + '?communityId=' + this.$store.state.streetorcommunityid;
      this.getQrcode()
      that = this

      if (sessionStorage.cityremark) {
        this.cityremark = sessionStorage.cityremark
        this.getFangyiList()
      }
      if (parseInt(this.$store.state.isJiedao)) {
        this.getChildShequ();
      } else {
        this.getZoneList(this.$store.state.streetorcommunityid)
      }

    }
  }
</script>

<style scoped lang="less">
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-date-picker {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  /deep/ .ivu-table-tip {
    overflow-x: hidden;
  }

  .wrapper {
    height: 100%;
  }

  .add-btn {
    min-width: 60px;
    height: 28px;
    line-height: 13px;
    display: block;
  }

  .del-btn {
    margin-bottom: 20px;
  }

  .tab-wrapper {
    position: absolute;
    left: 20px;
    .tab-btn {
      height: 30px;
      line-height: 30px;
      width: 85px;
      text-align: center;
      background: #fff;
      color: #999;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active {
      background: #ff7b44;
      color: #fff
    }
  }

  .nodata-card {
    margin: 0 20px 20px;
    align-items: center;
    justify-content: center;
    img {
      height: 280px;
      width: 390px;
    }
    .text {
      font-size: 15px;
      color: #ff7744;
      line-height: 1;
      padding: 25px 0 30px;
      letter-spacing: 10px;
      text-align: center;
    }
  }

  .card-box {
    margin: 0 20px 20px;
  }

  .table-card {
    padding: 20px 20px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }

  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }

  .qrCodeUrl-wrapper {
    width: 200px;
    margin:50px auto;
  }

  .qrCodeUrl {
    display: block;
    height: 200px;
    width: 100%;
    margin-bottom: 30px;
  }

  .qrcode-btn {
    background: #ff7b43;
    color: #fff;
    width: 150px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin: auto;
  }

  .note {
    font-size: 16px !important;
    margin-bottom: 20px;
    .download {
      color: #ff7b44;
      text-decoration: underline;
      margin-left: 5px;
    }
  }

  .btnsearch{
    display: flex;
    justify-content: flex-end;
  }
</style>
